import { style } from '@vanilla-extract/css';

export const card = style({
  backgroundColor: '#fff',
  borderRadius: '0.625rem', // 10px
  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  padding: '1.25rem', // 20px
});
